import UserTransformer from '@/transformers/users'
import Vue from 'vue'

/**
 * @author Suhipney Romero <suhiipney@gmail.com>
 *
 * @param user The user to create
 *
 * Creates a new zone
 * @return {Object} New user info
 */

export default (data) =>
  Vue.$http.post('/users/', UserTransformer.send(data))
    .then(({ data }) => UserTransformer.fetch(data))
